import { render, staticRenderFns } from "./customBoxQuestion.vue?vue&type=template&id=6c6ab671&scoped=true&"
import script from "./customBoxQuestion.vue?vue&type=script&lang=js&"
export * from "./customBoxQuestion.vue?vue&type=script&lang=js&"
import style0 from "./customBoxQuestion.vue?vue&type=style&index=0&id=6c6ab671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ab671",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c6ab671')) {
      api.createRecord('6c6ab671', component.options)
    } else {
      api.reload('6c6ab671', component.options)
    }
    module.hot.accept("./customBoxQuestion.vue?vue&type=template&id=6c6ab671&scoped=true&", function () {
      api.rerender('6c6ab671', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/customBoxQuestion.vue"
export default component.exports